<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useValidation from "@/use/Validation";
import useTools from "@/use/Tools";
import {useCodificationStore} from "@/stores/Setting/Codification";
import {onMounted, ref} from "vue";
import axios from "axios";
import {useClipboard} from "@/use/Clipboard";

export default {
    setup() {
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();
        const {mxRules} = useValidation();
        const {$refs, $route} = useTools();
        const {copyToClipboard} = useClipboard();
        
        const codificationStore = useCodificationStore();
        
        const codification = ref({editable: false});
        
        function findById(id) {
            loading.value = true;
            axios.get(`/codifications/${id}`).then((response) => {
                codification.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function update() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put('/codifications', codification.value).then((response) => {
                    codificationStore.updateCodification(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        onMounted(() => findById($route.params.id));
        
        return {
            mxRules,
            loading,
            dialog,
            codification,
            getBack,
            update,
            copyToClipboard,
        }
    }
}
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="600"
    >
        <v-card flat>
            <w-dialog-toolbar update-action/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <w-label :label="$t('common.prefix')"/>
                                <w-text-field v-model="codification.prefix"/>
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.value')" required/>
                                <w-text-field
                                    v-model="codification.value"
                                    type="number"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.size')" required/>
                                <w-text-field
                                    v-model="codification.size"
                                    type="number"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.suffix')"/>
                                <w-text-field v-model="codification.suffix"/>
                            </v-col>
                            <v-col cols="12">
                                <v-switch
                                    v-model="codification.editable"
                                    hide-details
                                    inset
                                >
                                    <template v-slot:label>
                                        <strong>{{ $t('common.editable') }}</strong>
                                    </template>
                                </v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <w-chip
                    text="[#ANNEE#]"
                    @press="copyToClipboard('[#ANNEE#]')"
                />
                <w-chip
                    text="[#MOIS#]"
                    @press="copyToClipboard('[#MOIS#]')"
                />
                <w-chip
                    text="[#JOUR#]"
                    @press="copyToClipboard('[#JOUR#]')"
                />
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-update
                    show
                    :loading="loading"
                    @press="update"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
